
export const AppRoute = {
  MainPage: "/",
  NotFound: "*",
  News: "/newslist",
  // Rosseti: "/Rosseti",
  ACM: "/ACM",
  Transneft: "/Transneft",
  Lenenergo: "/Lenenergo",
  RZA: "/RZA",
  Partners: "/Partners",
  NewsItem: "/newsitem/:id",
  MiningIndustry: "/miningindustry",
  Transport: "/transport",
  Production: "/production",
  TimeAttendanceSystem: "/Time&AttendanceSystem",
  Telecommunication: "/TelecommunicationAsetsAccountingSystem",
  EnergyFacilities: "/AutomationSystemForDesigningWindEnergyFacilities",
  AutomationStation: "/automationstation",
  AutomationGeneration: "/automationgeneration",
  AutomationDispatchControl: "/automationdispatchcontrol",
  AutomationAlternativeGeneration: "/automationalternativegeneration",
  AutomationPowerSupply: "/automationpowersupply",
  SKSU: "sksu",
  SKSUClient: "sksuclient",
  IntegratedDevices: "integrateddevices",
  TestProgramsAndMethods: "/testprogramsandmethods",
  TechnicalSupport: "/technicalsupport",
  TechnicalRequirements: "/technicalrequirements",
  ScientificDevelopmentAndResearch: "/scientificDevelopmentAndResearch",
  ProjectDocumentation: "/projectDocumentation",
  OperationalDocumentation: "/operationalDocumentation",
  Implementation: "/Implementation",
  SurveyReport: "/SurveyReport",
  DemoForm: "/DemoForm",
  //components
  SwitchBlanck: "switchblank",
  AndroidVersion: "androidversion",
  StateMonitor: "statemonitor",
  Transmission60870: "transmission60870",
  Transmission61850: "transmission61850",
  CronTask: "crontask",
  ConnectDevice61850: "connectdevice61850",
  DesktopApplication: "desktopapplication",
  MultimonitorApplication: "multimonitorapplication",
  TouchPanelApplication: "touchpanelapplication",
  NPTMobile: "nptmobile",
  IED: "ied",
  RPAMonitor: "rpamonitor",
  TrafficAnalyzer: "trafficanalyzer",
  ReportBuilder: "reportbuilder",
  IEC61131: "iec61131",
  IEC61850Server: "iec61850server",
  IEC61850Client: "iec61850client",
  IEC608705104Server: "iec608705104server",
  SMTPClient: "smtpclient",
  MQTTClient: "mqttclient",
  RabbitMQClient: "rabbitmqclient",
  KafkaClient: "kafkaclient",
  SNMPClient: "snmpclient",
  ODBCClient: "odbcclient",
  OscilloscopePlugin: "oscilloscopeplugin",
  MapPlugin: "mapplugin",
  VideoPlugin: "videoplugin",
  TopologyAnalysis: "topologyanalysis",
  ModeCalculation: "modecalculation",
  StateEstimation: "stateestimation",
  SCCalulation: "sccalculation",
  DispatcherSimulator: "dispatchersimulator",
  //Implementations
  IntegRPAMonitor: "rpamonitorintegration",
  IntegTrafficAnalyzer: "trafficanalyzerintegration",
  IntegWEBSCADA: "webscadaintegration",
  IntegIntelectualSCADA: "intellectualscadaintegration",
  OPCUAClient: 'opcuaclient',
  OPCUAServer: 'opcuaserver',
  SwitchingBlankEditor: 'switchingblankeditor',
  SCADAStudio: 'scadastudio',
};

export const news = [
  {
    title: `SCADA NPT Expert внесена в реестр российского ПО: новый шаг в развитии отечественных технологий `,
    data: "28.06.2017",
    id: 1,
    page: `Мы рады сообщить Вам, что система управления и сбора данных SCADA NPT Expert успешно внесена в единый реестр российских программ для электронных вычислительных машин и баз данных. Решение о включении было принято Министерством цифрового развития, связи и массовых коммуникаций Российской Федерации.

SCADA NPT Expert — это современная система для автоматизации, мониторинга и управления технологическими процессами. Ее включение в реестр подтверждает соответствие требованиям российского законодательства и подчеркивает важность развития отечественных IT-решений в условиях импортозамещения. С внесением в реестр система станет еще более доступной для широкого круга предприятий, способствуя цифровой трансформации промышленности России.
    
ГК "ЭнергопромАвтоматизация", разработчик SCADA NPT Expert, продолжает совершенствовать систему, ориентируясь на потребности рынка и актуальные вызовы в области автоматизации и цифровизации.

Благодарим за ваше внимание к нашей системе. Попробуйте [SCADA NPT Expert](https://epsa-spb.ru/kontakty-2/) и оцените ее возможности уже сегодня!  

[Реестровая запись №3640](https://reestr.digital.gov.ru/reestr/304990/) от 28.06.2017`,
    image: 'minsvyazi.png',
  },
  {
    title: `АСМ РЗА NPT RPA Monitor включен в реестр российского ПО: новый этап развития отечественных решений для энергетики и промышленности`,
    data: "28.10.2024",
    id: 2,
    page: `Мы рады сообщить Вам, что автоматизированная система мониторинга устройств релейной защиты и автоматики (АСМ РЗА) NPT RPA Monitor официально внесена в единый реестр российских программ для электронных вычислительных машин и баз данных. Решение о включении принято Министерством цифрового развития, связи и массовых коммуникаций Российской Федерации.

[NPT RPA Monitor](https://scada-npt-compact.ru/rpamonitor/) — это инновационная система, предназначенная для мониторинга, диагностики и анализа работы устройств релейной защиты и автоматики. Ее включение в реестр подтверждает соответствие системы требованиям российского законодательства и подчеркивает ее значимость для цифровизации энергетической инфраструктуры страны.
    
ГК "ЭнергопромАвтоматизация", разработчик NPT RPA Monitor, продолжает совершенствовать систему, ориентируясь на потребности рынка и современные вызовы в области автоматизации и цифровизации энергетики и других стратегически важных отраслей.

Благодарим за ваше внимание к нашей системе. Попробуйте [NPT RPA Monitor](https://epsa-spb.ru/kontakty-2/) и оцените его возможности уже сегодня!  

[Реестровая запись №24588](https://reestr.digital.gov.ru/reestr/2757888/) от 28.10.2024`,
    image: 'minsvyazi.png',
  },
  {
    title: `Анализатор трафика NPT Traffic Analyzer включен в реестр российского ПО: новый инструмент для контроля сетей энергетических объектов`,
    data: "27.11.2024",
    id: 3,
    page: `Мы рады сообщить Вам, что анализатор трафика NPT Traffic Analyzer внесен в единый реестр российских программ для электронных вычислительных машин и баз данных. Решение о включении принято Министерством цифрового развития, связи и массовых коммуникаций Российской Федерации.

[NPT Traffic Analyzer](https://scada-npt-compact.ru/trafficanalyzer/) — это специализированное решение, предназначенное для проверки параметров локальной вычислительной сети электрической подстанции, а также анализа сообщений, передаваемых по сети, на соответствие файлам настройки и международному стандарту МЭК 61850. Включение системы в реестр подтверждает ее соответствие требованиям российского законодательства и подчеркивает важность разработки отечественных решений для цифровизации энергетической отрасли.
    
ГК "ЭнергопромАвтоматизация", разработчик NPT Traffic Analyzer, продолжает совершенствовать продукт, ориентируясь на потребности энергетической отрасли и современные вызовы в области цифровой трансформации.

Благодарим за ваше внимание к нашей системе. Попробуйте [NPT Traffic Analyzer](https://epsa-spb.ru/kontakty-2/) и оцените его возможности уже сегодня!  

[Реестровая запись №24946](https://reestr.digital.gov.ru/reestr/2839897/) от 27.11.2024`,
    image: 'minsvyazi.png',
  },

  // {
  //   title: "Обновление платформы - версия 2.2.9",
  //   data: "06.09.2024 17:10",
  //   id: 18,
  //   page: (
  //     <ArticleVersion
  //       points={[
  //         "Исправлена ошибка в таблице c пагинацией при переходе на последнюю страницу",
  //         "Backport 2.3: Реализована поддержка хранимых асинхронных задач",
  //         "Backport 2.3: Сохранение SecurityContext (пользователя) в асинхронных задачах",
  //         "Добавлена проверка необходимости переиндексации ветвей для уменьшения количества транзакций",
  //       ]}
  //     />
  //   ),
  //   image: release,
  // },
];

export const code = `
<table xmlns="http://npt-platform.com/table" id="substationTable">
  <source>
    <finder classList="cim:Substation" pageable="true">      
    </finder>
  </source>
  <header>
      <column label="Административно-территориальная единица" field="region" path="cim:Substation.Region.cim.IdentifiedObject.name" filter-strategy="string"></column>
      <column label="Наименование ПС" field="label" path="cim:IdentifiedObject.name" filter-strategy="string"></column>
      <column label="Распределительные устройства" field="voltageLevel" path="cim:Substation.VoltageLevels.cim.IdentifiedObject.name" filter-strategy="string"></column>
  </header>
</table>
`;

export const code2 = `
  var query = require('query');
  var table = require('table');

  table.select(function(request) {
    var qb = query.instanceOf('cim:Substation')
    .join("voltageLevel", "cim:Substation.VoltageLevels")
    .equal('voltageLevel[cim.IdentifiedObject.name]', 'ОРУ 500 кВ')  
    return qb;
  });
`;

export const code3 = `
<tree xmlns="http://npt-platform.com/tree" id="registry">
  <branch id="GR" select="cim:GeographicalRegion" icon="npt-i-electrical-unit" icon-color="#418FDE">      
    <add id="addSGR" class="cim:SubGeographicalRegion" parent-ref="cim:SubGeographicalRegion.Region"/>
    <branch id="SGR" select="cim:SubGeographicalRegion" icon="npt-i-eg-alter" icon-color="#FFBE33">
      <add id="addSubstation" class="cim:Substation" parent-ref="cim:Substation.Region"/>      
      <branch id="Substation" select="cim:Substation" icon="npt-i-ps" icon-color="#228B22"></branch> 
    </branch> 
  </branch> 
</tree>
`;

export const code4 = `
"toolbar": [
  {
    "id": "export",
    "type": "group",
    "label": "Экспорт",     
    "group": [
      {
        "id": "exportSubjectsProfile",
        "label": "Экспорт профиля субъектов ПС"
      },
      {
        "id": "exportSubjectsModel",
        "label": "Экспорт субъектов ПС"
      }            
    ]
  },        
  {
    "id": "Reports",
    "type": "button",
    "label": "Отчеты"
  }
]
`;

export const code5 = `
"content": [
  {
    "ui": "grid-cell",
    "content": [
      {
      "ui": "predicate-placeholder",
      "ref": "cim:IdentifiedObject.name"
      },
      {
      "ui": "predicate-placeholder",
      "ref": "cim:IdentifiedObject.mRID",
      "options": {
        "label": "Идентификатор в мастер системе"
        }
      },
      {
        "ui": "predicate-placeholder",
        "ref": "cim:Substation.Region"
      }
    ]
  }
]
`;

export const code6 = `
var query = require('query');
var model = require('model');

model.build('substationModel', 'rdf/xml', function() {
  return model
    .over(query.instanceOf(
    'cim:Substation', 
    'cim:PowerSystemResource', 
    'cim:TransformerEnd'
  ) .primitives(true)
    .subjectRelations(true)
});
`;

export const code7 = `
var files = require('files');
var printRDF = require('print').printRDF;

var adapter = files.loadRDFModel('model.rdf');
var profile = files.loadXSDProfile('profile.xsd');
adapter.setProfile(profile);
printRDF(adapter);
`;

export const technicalSolutionsLinks = [
  {
    title: "NPT RPA Monitor",
    link: AppRoute.RPAMonitor,
  },
  {
    title: "NPT Traffic Analyzer",
    link: AppRoute.TrafficAnalyzer,
  },
  {
    title: "NPT Intelligent End Device",
    link: AppRoute.IED,
  },
];

technicalSolutionsLinks.sort((a, b) => a.title.localeCompare(b.title));


export const implementationExamples = [
  {
    title: "Подстанции",
    link: AppRoute.AutomationStation,
  },
  {
    title: "Генерация",
    link: AppRoute.AutomationGeneration,
  },
  {
    title: "Альтернативная генерация (ВЭС/СЭС)",
    link: AppRoute.AutomationAlternativeGeneration,
  },
  {
    title: "Диспетчерское управление электросетями",
    link: AppRoute.AutomationDispatchControl,
    isExpertPlus: true
  },
  {
    title:
      "Диспетчерское управление электроснабжением промышленного предприятия",
    link: AppRoute.AutomationPowerSupply,
    isExpertPlus: true
  },
  {
    title:
      "Транспорт",
    link: AppRoute.Transport,
    isExpertPlus: true
  },
];





export const pluginsLinks = [
  {
    list: [
      {
        title: "Клиенты",
        list: [
          {
            title: "Приложение для рабочего стола",
            link: AppRoute.DesktopApplication,
          },
          {
            title: "Приложение для нескольких мониторов/видеостен",
            link: AppRoute.MultimonitorApplication,
            isExpertPlus: true
          },
          // {
          //   title: "Приложение для сенсорных панелей",
          //   link: AppRoute.TouchPanelApplication,
          //   isExpertPlus: true
          // },
          {
            title: "Приложение для мобильных устройств",
            link: AppRoute.NPTMobile,
          },
        ],
      },
      {
        title: "Программное обеспечение",
        list: [
          {
            title: "Среда конфигурирования SCADA Studio",
            link: AppRoute.SCADAStudio,
          },
          {
            title: "Программное обеспечение СКСУ",
            link: AppRoute.SKSU,
          },
        ],
      },
      {
        title: "Автоматизация и логическая обработка",
        list: [
          {
            title: "Конструктор отчетов",
            link: AppRoute.ReportBuilder,
          },
          {
            title: "МЭК 61131",
            link: AppRoute.IEC61131,
          },
          {
            title: "Периодические задачи",
            link: AppRoute.CronTask,
          },
          {
            title: "Редактор бланков переключений",
            link: AppRoute.SwitchingBlankEditor,
          },
        ],
      },
    ],
  },
  {
    list: [
      {
        title: "Протоколы передачи данных",
        list: [
          {
            title: "МЭК 61850 Клиент",
            link: AppRoute.IEC61850Client,
          },
          {
            title: "МЭК 61850 Сервер",
            link: AppRoute.IEC61850Server,
          },
          {
            title: "МЭК 60870-5-104 Сервер",
            link: AppRoute.IEC608705104Server,
          },
          {
            title: "MQTT Клиент",
            link: AppRoute.MQTTClient,

          },
          {
            title: "RabbitMQ Клиент",
            link: AppRoute.RabbitMQClient,

          },
          {
            title: "Kafka Клиент",
            link: AppRoute.KafkaClient,

          },
          {
            title: "SMTP Клиент",
            link: AppRoute.SMTPClient,
          },
          {
            title: "SNMP Клиент",
            link: AppRoute.SNMPClient,
          },
          {
            title: "ODBC Клиент",
            link: AppRoute.ODBCClient,
          },
          {
            title: "СКСУ Клиент",
            link: AppRoute.SKSUClient,
          },
          {
            title: "OPC UA Клиент",
            link: AppRoute.OPCUAClient,
          },
          {
            title: "OPC UA Сервер",
            link: AppRoute.OPCUAServer,
          },
        ],
      },
      {
        title: "Графические плагины",
        list: [
          {
            title: "Просмотровщик осциллограмм",
            link: AppRoute.OscilloscopePlugin,
          },
          {
            title: "Интерактивная географическая карта",
            link: AppRoute.MapPlugin,
            isExpertPlus: true
          },
          // {
          //   title: "Отображение видеоинформации",
          //   link: AppRoute.VideoPlugin,
          //   isExpertPlus: true
          // },
        ],
      },
    ],
  },

  // Тренажер диспетчера
  {
    title: "Опции для электроэнергетики на базе CIM",
    list: [
      {
        title: "Топологический анализ",
        link: AppRoute.TopologyAnalysis,
        isExpertPlus: true
      },
      {
        title: "Расчет режима",
        link: AppRoute.ModeCalculation,
        isExpertPlus: true
      },
      {
        title: "Оценивание состояния",
        link: AppRoute.StateEstimation,
        isExpertPlus: true
      },
      {
        title: "Расчет ТКЗ",
        link: AppRoute.SCCalulation,
        isExpertPlus: true
      },
      {
        title: "Тренажер диспетчера",
        link: AppRoute.DispatcherSimulator,
        isExpertPlus: true
      },
      {
        title: "Автоматическое формирование бланков переключений",
        link: AppRoute.SwitchBlanck,
        isExpertPlus: true
      },
    ],
  },
];